import React from 'react';

// Text component for typography
const TextComponent = ({ 
  text = 'Dies ist ein Beispieltext. Sie können ihn bearbeiten und anpassen.',
  size = 'base',
  align = 'left',
  color = 'slate-700',
  weight = 'normal',
  style = 'normal'
}) => {
  const getSizeClass = () => {
    switch (size) {
      case 'xs': return 'text-xs';
      case 'sm': return 'text-sm';
      case 'base': return 'text-base';
      case 'lg': return 'text-lg';
      case 'xl': return 'text-xl';
      case '2xl': return 'text-2xl';
      default: return 'text-base';
    }
  };

  const getWeightClass = () => {
    switch (weight) {
      case 'thin': return 'font-thin';
      case 'light': return 'font-light';
      case 'normal': return 'font-normal';
      case 'medium': return 'font-medium';
      case 'semibold': return 'font-semibold';
      case 'bold': return 'font-bold';
      default: return 'font-normal';
    }
  };

  const getAlignClass = () => {
    switch (align) {
      case 'left': return 'text-left';
      case 'center': return 'text-center';
      case 'right': return 'text-right';
      case 'justify': return 'text-justify';
      default: return 'text-left';
    }
  };

  const getColorClass = () => {
    switch (color) {
      case 'slate-900': return 'text-slate-900 dark:text-slate-100';
      case 'slate-700': return 'text-slate-700 dark:text-slate-300';
      case 'slate-500': return 'text-slate-500 dark:text-slate-400';
      case 'blue-600': return 'text-blue-600 dark:text-blue-400';
      case 'green-600': return 'text-green-600 dark:text-green-400';
      case 'red-600': return 'text-red-600 dark:text-red-400';
      case 'yellow-600': return 'text-yellow-600 dark:text-yellow-400';
      case 'purple-600': return 'text-purple-600 dark:text-purple-400';
      default: return 'text-slate-700 dark:text-slate-300';
    }
  };

  const getStyleClass = () => {
    switch (style) {
      case 'normal': return '';
      case 'italic': return 'italic';
      case 'underline': return 'underline';
      case 'line-through': return 'line-through';
      default: return '';
    }
  };

  return (
    <p 
      className={`${getSizeClass()} ${getWeightClass()} ${getAlignClass()} ${getColorClass()} ${getStyleClass()} leading-relaxed`}
    >
      {text}
    </p>
  );
};

export const Text = {
  fields: {
    text: {
      type: 'textarea',
      label: 'Text'
    },
    size: {
      type: 'select',
      label: 'Schriftgröße',
      options: [
        { label: 'Sehr klein (XS)', value: 'xs' },
        { label: 'Klein (SM)', value: 'sm' },
        { label: 'Normal (Base)', value: 'base' },
        { label: 'Groß (LG)', value: 'lg' },
        { label: 'Größer (XL)', value: 'xl' },
        { label: 'Sehr groß (2XL)', value: '2xl' }
      ]
    },
    align: {
      type: 'select',
      label: 'Ausrichtung',
      options: [
        { label: 'Links', value: 'left' },
        { label: 'Zentriert', value: 'center' },
        { label: 'Rechts', value: 'right' },
        { label: 'Blocksatz', value: 'justify' }
      ]
    },
    color: {
      type: 'select',
      label: 'Farbe',
      options: [
        { label: 'Dunkelgrau', value: 'slate-900' },
        { label: 'Mittelgrau', value: 'slate-700' },
        { label: 'Hellgrau', value: 'slate-500' },
        { label: 'Blau', value: 'blue-600' },
        { label: 'Grün', value: 'green-600' },
        { label: 'Rot', value: 'red-600' },
        { label: 'Gelb', value: 'yellow-600' },
        { label: 'Lila', value: 'purple-600' }
      ]
    },
    weight: {
      type: 'select',
      label: 'Schriftgewicht',
      options: [
        { label: 'Dünn', value: 'thin' },
        { label: 'Leicht', value: 'light' },
        { label: 'Normal', value: 'normal' },
        { label: 'Mittel', value: 'medium' },
        { label: 'Halbfett', value: 'semibold' },
        { label: 'Fett', value: 'bold' }
      ]
    },
    style: {
      type: 'select',
      label: 'Textstil',
      options: [
        { label: 'Normal', value: 'normal' },
        { label: 'Kursiv', value: 'italic' },
        { label: 'Unterstrichen', value: 'underline' },
        { label: 'Durchgestrichen', value: 'line-through' }
      ]
    }
  },
  render: TextComponent
};
